import React from 'react';

import { SCANNING_PEAK_HEATMAP_COLORS } from '../ScanningPeakHoursWidget.settings';
import classes from './HeatmapLegend.module.scss';

const HeatmapLegend = () => (
  <div className={classes.container}>
    <div className={classes.legendBar} role="presentation">
      {SCANNING_PEAK_HEATMAP_COLORS.map((color, index) => (
        <div
          // eslint-disable-next-line react/no-array-index-key
          key={index}
          style={{ backgroundColor: color }}
        />
      ))}
    </div>
    <div className={classes.legendLabels}>
      <span>Less</span>
      <span>Highest</span>
    </div>
  </div>
);

export { HeatmapLegend };
